import typia from "typia";
import type {WritableSignal} from '@angular/core';
import {SignupFormState} from "../pages/signup/signup-form.service";
import {User} from "./user.service";
import {ExternalCode} from "./external-code.service";
import {FederatedAuthPlatform, FederatedAuthTokens} from "./auth/federated-auth.service";
import {OAuthState} from "./auth/auth.service";

type Is<T> = (value: unknown) => value is T;
export type TypeFromTypia<T> = T extends Is<infer U> ? U : never;

export const keyTypeMapping = {
  AUTH_TOKENS: typia.is<FederatedAuthTokens>,
  AUTH_TYPE: typia.is<FederatedAuthPlatform | 'username-password'>,
  LAST_USER_STATUS: typia.is<User['status']>,
  LAST_USER_ID: typia.is<string>,
  SIGNUP_FORM_STATE: typia.is<SignupFormState>,
  EXTERNAL_CODE: typia.is<ExternalCode>,
  REFERRAL_POPUP_COUNT: typia.is<number>,
  BILLING_MODE: typia.is<'monthly' | 'annual'>,
  PROMOTION: typia.is<boolean>,
  OATH_STATE: typia.is<OAuthState>,
  HOMEY_EXPLANATION_SHOWN: typia.is<boolean>,
  APPLICATION_GUIDE_SHOWN: typia.is<boolean>,
  REQUESTED_INITIAL_PUSH_PERMISSION: typia.is<boolean>,
  PAST_DUE_FLOW_STARTED: typia.is<boolean>,
  STATUS_UPDATE_NOTIFICATION_LAST_SHOWN: typia.is<string>,
  STATUS_UPDATE_NOTIFICATION_ACTIVATED_DATE: typia.is<string>,
} as const;

export type StorageKey = keyof typeof keyTypeMapping;

export abstract class StorageService {
  abstract setItem<T extends StorageKey>(key: T, value: TypeFromTypia<typeof keyTypeMapping[T]>): Promise<void>;
  abstract updateItem<T extends StorageKey>(key: T, updateFn: (value: TypeFromTypia<typeof keyTypeMapping[T]> | undefined) => TypeFromTypia<typeof keyTypeMapping[T]>): Promise<void>;
  abstract getItem<T extends StorageKey>(key: T): Promise<TypeFromTypia<typeof keyTypeMapping[T]> | undefined>;
  abstract generateItemSignal<T extends StorageKey>(key: T, initialValue: TypeFromTypia<typeof keyTypeMapping[T]>): WritableSignal<TypeFromTypia<typeof keyTypeMapping[T]>>;
  abstract removeItem<T extends StorageKey>(key: T): Promise<void>;
  abstract clear(): Promise<void>;
}
